module.exports = __webpack_public_path__ + "static/media/Dell-XPS-15-7590-Laptop.d4ad03f4.webp";